// @flow
import { createReducer } from "redux-act";

const initialState = [
	{ key: 'playing', value: 'Playing' },
	{ key: 'not-playing', value: 'Not playing' },
	{ key: 'injured', value: 'Injured' },
	{ key: 'uncertain', value: 'Uncertain' },
	{ key: 'is-bye', value: 'Has bye' },
];

export const playerStatuses = createReducer({}, initialState);

export default playerStatuses;


// WEBPACK FOOTER //
// ./src/modules/reducers/playerStatuses/index.js